import { useEffect, useRef } from 'react';

import {
  parseStickyUtmSources,
  persistStickyUtmSource,
} from '../utils/stickyUtmUtils';

// Persists a campaign utm_source so it survives the shopping session being recreated
const useStickyUtmCapture = ({
  utmSource,
  isConfigReady,
  stickyUtmSources,
  stickyUtmTtlSeconds,
}) => {
  const hasCapturedRef = useRef(false);

  useEffect(() => {
    if (!isConfigReady || hasCapturedRef.current) {
      return;
    }

    // Latch before persisting so a re-render cannot refresh the TTL
    hasCapturedRef.current = true;

    // No-op for values not in config, so this is safe to call
    persistStickyUtmSource(
      utmSource,
      parseStickyUtmSources(stickyUtmSources),
      stickyUtmTtlSeconds
    );
  }, [utmSource, isConfigReady, stickyUtmSources, stickyUtmTtlSeconds]);
};

export default useStickyUtmCapture;
